export default __webpack_public_path__ + "ebf0e077894bcfa735213563bace6d72.png";